// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_OrderController_GetList_OwnerType,
  QueryInput_OrderController_GetList_SortOrder,
  useOrderGetListQuery,
} from 'api/generated/graphql';
import { parseOrdersListItemData, useError } from 'api/helpers';
import {
  OrdersListItemData,
  ListDataQueryFunction,
  OrdersSortField,
} from 'api/types/data';
import { ListData } from 'api/types/data/listData';
import { lodash } from 'helpers';

export const useOrderGetList: ListDataQueryFunction<
  OrdersListItemData,
  {},
  OrdersSortField,
  { ownerId: string; ownerType: 'Client' | 'LegalClient' }
> = ({ pagination, sort, params }) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOrderGetListQuery({
    variables: {
      limit: pagination.limit,
      page: pagination.page + 1,
      sortBy: sort?.field,
      sortOrder: (sort?.sort === 'asc'
        ? 'ASC'
        : 'DESC') as QueryInput_OrderController_GetList_SortOrder,
      ownerId: params.ownerId,
      ownerType: QueryInput_OrderController_GetList_OwnerType[params.ownerType],
    },
  });

  const error = useError(apolloError);

  const listData: ListData<OrdersListItemData> | undefined = data?.orders
    ? {
        total: data?.orders?.total,
        list: lodash.compact(data?.orders.list).map(parseOrdersListItemData),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
